export const types = {
    //Auth Actions//
    LOGIN_START: 'LOGIN_START',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    ERROR_CLEAN: 'ERROR_CLEAN',

    //Registration//
    REGISTER_USER_START: 'REGISTER_USER_START',
    REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS',
    REGISTER_USER_FAILURE: 'REGISTER_USER_FAILURE',

    //Mothers Actions//
    GET_MOTHERS_START: 'GET_MOTHERS_START',
    GET_MOTHERS_SUCCESS: 'GET_MOTHERS_SUCCESS',
    GET_MOTHERS_FAILURE: 'GET_MOTHERS_FAILURE',

    GET_MOTHER_START: 'GET_MOTHER_START',
    GET_MOTHER_SUCCESS: 'GET_MOTHER_SUCCESS',
    GET_MOTHER_FAILURE: 'GET_MOTHER_FAILURE',

    ADD_MOTHERS_START: "ADD_MOTHERS_START",
    ADD_MOTHERS_SUCCESS: "ADD_MOTHERS_SUCCESS",
    ADD_MOTHERS_FAILURE: "ADD_MOTHERS_FAILURE",

    UPDATE_MOTHER_START: "UPDATE_MOTHER_START",
    UPDATE_MOTHER_SUCCESS: "UPDATE_MOTHER_SUCCESS",
    UPDATE_MOTHER_FAILURE: "UPDATE_MOTHER_FAILURE",

    DELETE_MOTHER_START: "DELETE_MOTHER_START",
    DELETE_MOTHER_SUCCESS: "DELETE_MOTHER_SUCCESS",
    DELETE_MOTHER_FAILURE: "DELETE_MOTHER_FAILURE",

    //Drivers Actions//
    GET_DRIVERS_START: 'GET_DRIVERS_START',
    GET_DRIVERS_SUCCESS: 'GET_DRIVERS_SUCCESS',
    GET_DRIVERS_FAILURE: 'GET_DRIVERS_FAILURE',

    ADD_DRIVERS_START: 'ADD_DRIVERS_START',
    ADD_DRIVERS_SUCCESS: 'ADD_DRIVERS_SUCCESS',
    ADD_DRIVERS_FAILURE: 'ADD_DRIVERS_FAILURE',

    UPDATE_DRIVERS_START: 'UPDATE_DRIVERS_START',
    UPDATE_DRIVERS_SUCCESS: 'UPDATE_DRIVERS_SUCCESS',
    UPDATE_DRIVERS_FAILURE: 'UPDATE_DRIVERS_FAILURE',

    DELETE_DRIVERS_START: 'DELETE_DRIVERS_START',
    DELETE_DRIVERS_SUCCESS: 'DELETE_DRIVERS_SUCCESS',
    DELETE_DRIVERS_FAILURE: 'DELETE_DRIVERS_FAILURE',

    //logout types
    LOGOUT: 'LOGOUT',

    //Label Actions (Mothers)
    GET_LABELS_START: 'GET_DRIVERS_START',
    GET_LABELS_SUCCESS: 'GET_LABELS_SUCCESS',
    GET_LABELS_FAILURE: 'GET_LABELS_FAILURE',
    //Create Label for mother

    CREATE_LABEL_START: 'CREATE_LABEL_START',
    CREATE_LABEL_SUCCESS: 'CREATE_LABEL_SUCCESS',
    CREATE_LABEL_FAILURE: 'CREATE_LABEL_FAILURE',
    //Delete Label

    DELETE_LABEL_START: 'DELETE_LABEL_START',
    DELETE_LABEL_SUCCESS: 'DELETE_LABEL_SUCCESS',
    DELETE_LABEL_FAILURE: 'DELETE_LABEL_FAILURE',
    
    //Settings
    CREATE_USER_START: 'CREATE_USER_START',
    CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
    CREATE_USER_FAILURE: 'CREATE_USER_FAILURE',

    GET_USERS_START: 'GET_USERS_START',
    GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
    GET_USERS_FAILURE: 'GET_USERS_FAILURE',

    EDIT_USERS_START: 'EDIT_USERS_START',
    EDIT_USERS_SUCCESS: 'EDIT_USERS_SUCCESS',
    EDIT_USERS_FAILURE: 'EDIT_USERS_FAILURE',

    DELETE_USERS_START: 'DELETE_USERS_START',
    DELETE_USERS_SUCCESS: 'DELETE_USERS_SUCCESS',
    DELETE_USERS_FAILURE: 'DELETE_USERS_FAILURE',


};

export const ERROR = "error";
